export const FETCH_QUESTIONNAIRES_STATISTICS   = 'FETCH_QUESTIONNAIRES_STATISTICS';
export const FETCH_QUESTION_GROUPS   = 'FETCH_QUESTION_GROUPS';